import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Dialog } from '@material-ui/core';
import { PaperComponent } from '../DraggablePaper.js';
import { toDateFormat } from '../../../utils/Util.js';
import axios from 'axios';
import { Calendar, Views, momentLocalizer } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css';

import moment from 'moment'
import 'moment/locale/hu'
import 'moment-timezone'

require('globalize/lib/cultures/globalize.culture.hu')

function MyCalendar(props) {

    const [displayedData, setDisplayedData] = useState([]);
    const [holidays, setHolidays] = useState([]);
    const [newEventDialogOpen, setNewEventDialogOpen] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();


    const messages = {
        week: 'Hét',
        work_week: 'Munkahét',
        day: 'Nap',
        month: 'Hónap',
        previous: 'Előző',
        next: 'Következő',
        today: 'Ma',
        agenda: 'Agenda',

        showMore: (total) => `+${total} több`,
    }

    const refreshState = () => {
        console.log("refresh");
        callApi()
            .then(res => setDisplayedData(res))
            .catch(err => console.log(err));
    }

    const callApi = useCallback(async () => {
        const response = await axios.get(props.newEventApi)
        return props.enrich(response);
    }, [props])

    const callHolidayApi = useCallback(async () => {
        const response = await axios.get("https://openholidaysapi.org/PublicHolidays?countryIsoCode=HU&languageIsoCode=HU&validFrom=2022-01-01&validTo=2024-12-31")
        console.log(response.data);
        return response.data;
    }, [])

    useEffect(function () {
        callApi()
            .then(res => setDisplayedData(res))
            .catch(err => console.log(err));
        callHolidayApi()
            .then(res => setHolidays(res))
            .catch(err => console.log(err));
    }, [callApi, callHolidayApi]);

    const localizer = momentLocalizer(moment)
    localizer.segmentOffset = 0;

    const handleSelectSlot = useCallback(
        ({ start, end }) => {
            const startDate = new Date(start);
            const endDate = new Date(end);
            if (end.getHours() === 0) {
                endDate.setDate(endDate.getDate() - 1)
            }
            setStartDate(toDateFormat(startDate));
            setEndDate(toDateFormat(endDate));
            setNewEventDialogOpen(true);
        },
        []
    )

    const eventStyleGetter = (event, start, end, isSelected) => {
        var backgroundColor = '#' + event.hexColor;
        var style = {
            backgroundColor: backgroundColor,
            borderRadius: '0px',
            opacity: 0.8,
            color: 'black',
            border: '0px',
            display: 'block'
        };
        return {
            style: style
        };
    }
    const { defaultDate, formats, components } = useMemo(
        () => ({
            defaultDate: new Date(),
            formats: {
                monthHeaderFormat: (date, culture, localizer) =>
                    localizer.format(date, `YYYY MMMM`, culture),
                weekdayFormat: (date, culture, localizer) =>
                    localizer.format(date, 'dddd', culture),
            },
        }),
        []
    )

    //dialog

    const handleNewEventDialogClose = () => {
        console.log("close");
        setNewEventDialogOpen(false);
    }

    const isHoliday = useCallback((date) => {
        // console.log(date);
        // holidays.forEach
        for (let holiday of holidays) {
            const startDate = new Date(holiday.startDate).setHours(0);
            const endDate = holiday.endDate ? new Date(holiday.endDate).setHours(0) : startDate;
            if (date >= startDate && date <= endDate) {
                return true; // Date is within the range
            }
        }
        return false;
    }, [holidays])

    const dayPropGetter = useCallback(
        (date) => {
            /* eslint-disable no-mixed-operators */
            return {
                ...((date.getDay() === 0 || date.getDay() === 6) && { style: { backgroundColor: '#b8cce4' } } || isHoliday(date) && { style: { backgroundColor: '#fcd6b4' } })
            }
        }, [isHoliday])

    return (
        <>
            <div className="height600">
                <Calendar
                    localizer={localizer}
                    culture='hu'
                    defaultDate={defaultDate}
                    messages={messages}
                    events={displayedData}
                    showMultiDayTimes
                    step={60}
                    eventPropGetter={eventStyleGetter}
                    views={[Views.MONTH, Views.WEEK, Views.DAY]}
                    formats={formats}
                    components={components}
                    showAllEvents='true'
                    onSelectSlot={handleSelectSlot}
                    selectable
                    dayPropGetter={dayPropGetter}
                />
            </div>
            <div className="dialog">
                <Dialog disableBackdropClick
                    disableScrollLock
                    PaperComponent={PaperComponent}
                    maxWidth={"sm"}
                    open={newEventDialogOpen}
                    onClose={handleNewEventDialogClose}
                    aria-labelledby="form-dialog-title">
                    <div className="modal-form">
                        <button className="close-modal-btn lnr-cross" onClick={handleNewEventDialogClose}></button>
                        <h2 id="draggable-dialog-title">{props.newEventDialogTitle}</h2>
                        {/* <NewVacationForDates start={startDate} end={endDate} refresh={() => refreshState()} close={() => handleDialogClose()} /> */}
                        {props.newEventDialogContent(startDate, endDate, refreshState, () => handleNewEventDialogClose())}
                    </div>
                </Dialog>
            </div>
        </>
    );

}

export default MyCalendar;